import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ForecastListItemFragment = { __typename?: 'ForecastDocument', forecastId: string, name: string, description: string, customerId: string, programIds: Array<string>, startDate: Types.TDateISO, endDate: Types.TDateISO, level: Types.ForecastLevel, weeklyMetric: Types.ForecastWeeklyMetric, scenarioSlot: Types.ForecastScenarioSlot, status: Types.ForecastStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type GetForecastsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ForecastDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ForecastDocumentSortInput> | Types.ForecastDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetForecastsQuery = { __typename?: 'Query', forecasts?: { __typename?: 'ForecastsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ForecastDocument', forecastId: string, name: string, description: string, customerId: string, programIds: Array<string>, startDate: Types.TDateISO, endDate: Types.TDateISO, level: Types.ForecastLevel, weeklyMetric: Types.ForecastWeeklyMetric, scenarioSlot: Types.ForecastScenarioSlot, status: Types.ForecastStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetForecastQueryVariables = Types.Exact<{
  forecastId: Types.Scalars['String']['input'];
}>;


export type GetForecastQuery = { __typename?: 'Query', forecast?: { __typename?: 'ForecastDocument', forecastId: string, name: string, description: string, customerId: string, programIds: Array<string>, startDate: Types.TDateISO, endDate: Types.TDateISO, level: Types.ForecastLevel, weeklyMetric: Types.ForecastWeeklyMetric, scenarioSlot: Types.ForecastScenarioSlot, status: Types.ForecastStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null };

export type ForecastSettingsFieldsFragment = { __typename?: 'ForecastSettingsStateData', tenantId: string, compAim: number, compMin: number, compMax: number, excludedHistoryYears: Array<number>, maxYearOffset: number, roundingBias: number, shipShift: boolean, updatedAt: Types.TDateISO, updatedBy: string };

export type GetForecastSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetForecastSettingsQuery = { __typename?: 'Query', forecastSettings?: { __typename?: 'ForecastSettingsStateData', tenantId: string, compAim: number, compMin: number, compMax: number, excludedHistoryYears: Array<number>, maxYearOffset: number, roundingBias: number, shipShift: boolean, updatedAt: Types.TDateISO, updatedBy: string } | null };

export const ForecastListItemFragmentDoc = new TypedDocumentString(`
    fragment ForecastListItem on ForecastDocument {
  forecastId
  name
  description
  customerId
  programIds
  startDate
  endDate
  level
  weeklyMetric
  scenarioSlot
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ForecastListItem"});
export const ForecastSettingsFieldsFragmentDoc = new TypedDocumentString(`
    fragment ForecastSettingsFields on ForecastSettingsStateData {
  tenantId
  compAim
  compMin
  compMax
  excludedHistoryYears
  maxYearOffset
  roundingBias
  shipShift
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ForecastSettingsFields"});
export const GetForecastsDocument = new TypedDocumentString(`
    query GetForecasts($where: ForecastDocumentFilterInput, $order: [ForecastDocumentSortInput!], $first: Int, $after: String) {
  forecasts(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...ForecastListItem
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ForecastListItem on ForecastDocument {
  forecastId
  name
  description
  customerId
  programIds
  startDate
  endDate
  level
  weeklyMetric
  scenarioSlot
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetForecastDocument = new TypedDocumentString(`
    query GetForecast($forecastId: String!) {
  forecast(forecastId: $forecastId) {
    ...ForecastListItem
  }
}
    fragment ForecastListItem on ForecastDocument {
  forecastId
  name
  description
  customerId
  programIds
  startDate
  endDate
  level
  weeklyMetric
  scenarioSlot
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const GetForecastSettingsDocument = new TypedDocumentString(`
    query GetForecastSettings {
  forecastSettings {
    ...ForecastSettingsFields
  }
}
    fragment ForecastSettingsFields on ForecastSettingsStateData {
  tenantId
  compAim
  compMin
  compMax
  excludedHistoryYears
  maxYearOffset
  roundingBias
  shipShift
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetForecasts: build.query<GetForecastsQuery, GetForecastsQueryVariables | void>({
      query: (variables) => ({ document: GetForecastsDocument, variables })
    }),
    GetForecast: build.query<GetForecastQuery, GetForecastQueryVariables>({
      query: (variables) => ({ document: GetForecastDocument, variables })
    }),
    GetForecastSettings: build.query<GetForecastSettingsQuery, GetForecastSettingsQueryVariables | void>({
      query: (variables) => ({ document: GetForecastSettingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetForecastsQuery, useLazyGetForecastsQuery, useGetForecastQuery, useLazyGetForecastQuery, useGetForecastSettingsQuery, useLazyGetForecastSettingsQuery } = injectedRtkApi;
